import { handleActions } from 'redux-actions'
import * as type from './type'
import { LOCATION_CHANGE } from 'connected-react-router'

export const initialState = {
    customerId: null,
    treatmentQuotation: null,
    fetching: false,
    uploadingVideo: false,
    error: null,
    hasChanged: false,
    previewModalOpen: false,
    isEditableForUser: false,
}

const VIEW_VIDEO_URL = '/api/treatment/view-video-file?treatmentQuotationId='

export default handleActions(
    {
        [LOCATION_CHANGE]: (state, action) => {
            return {
                ...initialState,
            }
        },
        [type.CUSTOMER_LOADED]: (state, action) => {
            const { customer } = action.payload
            if (customer.treatmentQuotationList.length === 0) {
                return state
            }

            return {
                ...state,
                customer,
                treatmentQuotation: customer.treatmentQuotationList[0],
            }
        },
        [type.PROCESS_TASK_CUSTOMER_LOADED]: (state, action) => {
            const { salesOrder } = action.payload
            return {
                ...state,
                customerId: salesOrder.customerId,
                funnelId: salesOrder.funnelId,
            }
        },
        [type.FIND_OR_CREATE_TREATMENT_QUOTATION_REQUEST]: (state, action) => {
            return {
                ...state,
                fetching: true,
                error: null,
                treatmentQuotation: null,
            }
        },
        [type.FIND_OR_CREATE_TREATMENT_QUOTATION_SUCCESS]: (state, action) => {
            const { treatmentQuotation } = action.payload
            return {
                ...state,
                treatmentQuotation,
                fetching: false,
            }
        },
        [type.FIND_OR_CREATE_TREATMENT_QUOTATION_ERROR]: (state, action) => {
            const { error } = action.payload
            return {
                ...state,
                fetching: false,
                error,
            }
        },
        [type.CHANGE_TREATMENT_QUOTATION]: (state, action) => {
            const { name, value } = action.payload

            return {
                ...state,
                treatmentQuotation: {
                    ...state.treatmentQuotation,
                    [name]: value,
                },
                hasChanged: true,
            }
        },
        [type.CHANGE_TREATMENT_PACKAGE_PRICE]: (state, action) => {
            const { packageSize, price } = action.payload.value
            return {
                ...state,
                treatmentQuotation: {
                    ...state.treatmentQuotation,
                    packageSize,
                    brutPrice: price,
                },
                hasChanged: true,
            }
        },
        [type.SAVE_TREATMENT_QUOTATION_REQUEST]: (state, action) => {
            return {
                ...state,
                fetching: true,
                error: null,
            }
        },
        [type.SAVE_TREATMENT_QUOTATION_SUCCESS]: (state, action) => {
            const { treatmentQuotation } = action.payload
            return {
                ...state,
                treatmentQuotation,
                fetching: false,
                hasChanged: false,
            }
        },
        [type.SAVE_TREATMENT_QUOTATION_ERROR]: (state, action) => {
            const { error } = action.payload
            return {
                ...state,
                fetching: false,
                error,
            }
        },
        [type.OPEN_PREVIEW_MODAL]: (state, action) => {
            return {
                ...state,
                previewModalOpen: true,
            }
        },
        [type.CLOSE_PREVIEW_MODAL]: (state, action) => {
            return {
                ...state,
                previewModalOpen: false,
            }
        },
        [type.UPLOAD_SCAN_VIDEO_REQUEST]: (state, action) => {
            return {
                ...state,
                uploadingVideo: true,
            }
        },
        [type.UPLOAD_SCAN_VIDEO_SUCCESS]: (state, action) => {
            const { frontendUrl } = action.payload
            return {
                ...state,
                uploadingVideo: false,
                treatmentQuotation: {
                    ...state.treatmentQuotation,
                    treatmentLink:
                        frontendUrl +
                        VIEW_VIDEO_URL +
                        state.treatmentQuotation.id,
                },
                hasChanged: true,
            }
        },
        [type.UPLOAD_SCAN_VIDEO_ERROR]: (state, action) => {
            return {
                ...state,
                uploadingVideo: false,
            }
        },
        [type.SET_EDITABLE_FOR_USER]: (state, action) => {
            return {
                ...state,
                isEditableForUser: true,
            }
        },
    },
    initialState
)



// WEBPACK FOOTER //
// ./src/modules/treatment/state/quotation/reducer.js